import { render, staticRenderFns } from "./AppStack.vue?vue&type=template&id=c4a63124&scoped=true&"
import script from "./AppStack.vue?vue&type=script&lang=js&"
export * from "./AppStack.vue?vue&type=script&lang=js&"
import style0 from "./AppStack.vue?vue&type=style&index=0&id=c4a63124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a63124",
  null
  
)

export default component.exports